/* eslint-disable import/prefer-default-export */

import {
  BaseErrorKey,
} from '@vroskus/library-error';

/**
 *  @swagger
 *  components:
 *    schemas:
 *      Error:
 *        allOf:
 *          - $ref = '#/components/schemas/BaseError'
 *          - type: object
 *            properties:
 *              message:
 *                description: Message describing an error
 *                type: string
 *              key:
 *                description: Error code
 *                type: string
 *                enum:
 *                  - EMAIL_NOT_FOUND_ERROR
 *                  - EMAIL_OCCUPIED_ERROR
 *                  - FILE_NOT_FOUND
 *                  - INVALID_ACCESS_TOKEN_ERROR
 *                  - INVALID_ACCESS_TOKEN_TYPE_ERROR
 *                  - INVALID_AUTH_TOKEN_ERROR
 *                  - INVALID_CONFIRMATION_CODE_ERROR
 *                  - LOGIN_TYPE_INVALID_ERROR
 *                  - NO_PERMISSION_ERROR
 *                  - PASSWORD_MISMATCH_ERROR
 *                  - PASSWORD_NOT_SET_ERROR
 *                  - SENSORS_DATA_NOT_PROVIDED_ERROR
 *                  - UNKNOWN_SOCIAL_AUTH_STRATEGY_TYPE_ERROR
 *                  - UNRECOGNIZED_DEPLOYMENT_ENVIRONMENT_ERROR
 */

enum ProjectErrorKey {
  emailNotFoundError = 'EMAIL_NOT_FOUND_ERROR',
  emailOccupiedError = 'EMAIL_OCCUPIED_ERROR',
  fileNotFound = 'FILE_NOT_FOUND',
  invalidAccessTokenError = 'INVALID_ACCESS_TOKEN_ERROR',
  invalidAccessTokenTypeError = 'INVALID_ACCESS_TOKEN_TYPE_ERROR',
  invalidAuthTokenError = 'INVALID_AUTH_TOKEN_ERROR',
  invalidConfirmationCodeError = 'INVALID_CONFIRMATION_CODE_ERROR',
  loginTypeInvalidError = 'LOGIN_TYPE_INVALID_ERROR',
  noPermissionError = 'NO_PERMISSION_ERROR',
  passwordMismatchError = 'PASSWORD_MISMATCH_ERROR',
  passwordNotSetError = 'PASSWORD_NOT_SET_ERROR',
  sensorsDataNotProvidedError = 'SENSORS_DATA_NOT_PROVIDED_ERROR',
  unknownSocialAuthStrategyTypeError = 'UNKNOWN_SOCIAL_AUTH_STRATEGY_TYPE_ERROR',
  unrecognizedDeploymentEnvironmentError = 'UNRECOGNIZED_DEPLOYMENT_ENVIRONMENT_ERROR',
}

export const ErrorKey = {
  ...BaseErrorKey,
  ...ProjectErrorKey,
} as const;
